/**
 * Ticker
 * @module components/Ticker
 */

import React from 'react';
import { useSiteType } from 'context/siteType.context';
import {
	TickerWrapper,
	Date,
	PriceWrapper,
	Delta,
	ArrowDownRight,
	ArrowRight,
	ArrowUpRight,
} from './Ticker.styles';
import { lgGreen } from 'theme/colors';
interface Props {
	/** The Ticker date  */
	date?: string;

	/** The Ticker price  */
	price?: number;

	/** The Ticker trade currency  */
	tradeCurrency?: string;

	/** The Ticker delta value  */
	delta?: number;
}

const Ticker = ({ date, price, tradeCurrency, delta }: Props): JSX.Element => {
	const siteType = useSiteType();
	return (
		<TickerWrapper isLindabGroup={siteType === 'LindabGroup'}>
			{date && <Date>{date}</Date>}
			<PriceWrapper>
				{price && <span>{`${price.toFixed(2)} ${tradeCurrency}`}</span>}
				{delta && delta < 0 ? (
					<Delta deltaColor="errorRed">
						{delta.toFixed(2)}
						<ArrowDownRight aria-hidden={true} />
					</Delta>
				) : delta && delta > 0 ? (
					<Delta deltaColor={siteType === 'LindabGroup' ? lgGreen : 'green'}>
						{delta.toFixed(2)}
						<ArrowUpRight
							isLindabGroup={siteType === 'LindabGroup'}
							aria-hidden={true}
						/>
					</Delta>
				) : delta && delta == 0 ? (
					<Delta deltaColor="blue">
						{delta.toFixed(2)}
						<ArrowRight aria-hidden={true} />
					</Delta>
				) : (
					false
				)}
			</PriceWrapper>
		</TickerWrapper>
	);
};

export default Ticker;
